type Size = 'sm' | 'md'
type Tone = 'green' | 'ink'

type Props = {
  name: string
  size?: Size
  tone?: Tone
  className?: string
}

const SIZE_CLASS: Record<Size, string> = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
}

const TONE_CLASS: Record<Tone, string> = {
  green: 'bg-green-100 text-green-800',
  ink: 'bg-ink-100 text-ink-700',
}

const Avatar = ({
  name,
  size = 'md',
  tone = 'green',
  className = '',
}: Props) => {
  const initials = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((p) => p.charAt(0))
    .slice(0, 2)
    .join('')
    .toUpperCase()

  return (
    <span
      className={`rounded-full font-bold grid place-items-center flex-shrink-0 ${SIZE_CLASS[size]} ${TONE_CLASS[tone]} ${className}`}
      aria-hidden="true"
    >
      {initials || '?'}
    </span>
  )
}

export default Avatar
